import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'accountNumberToAstrix', pure: true, standalone: true})
export class AccountNumberToAstrixPipe implements PipeTransform {
  transform(value: string, numberOfDigitsToShow: number) {

    if (!value || !value.length) return '';

    if (numberOfDigitsToShow == null || numberOfDigitsToShow < 0) return '';

    const last4Digits = value.slice(-numberOfDigitsToShow);

    const maskedNumber = last4Digits.padStart(8, '*');

    return maskedNumber;
  }

  constructor() {
  }
}
